import { motion } from "motion/react";
import { lazy, useEffect, useState, type ReactElement } from "react";
import "./styles/LoadingScreen.scss";
import tips from "./store/tips";
import { shuffle } from "../Lib";
//https://blogfonts.com/segoe-mono-boot-1.font
//use charmap-
const items:ReactElement[]=[//length=117
  <>&#57426;</>,<>&#57427;</>,<>&#57428;</>,<>&#57429;</>,<>&#57430;</>,<>&#57431;</>,
  <>&#57432;</>,<>&#57433;</>,<>&#57434;</>,<>&#57435;</>,<>&#57436;</>,<>&#57437;</>,
  <>&#57438;</>,<>&#57439;</>,<>&#57440;</>,<>&#57441;</>,<>&#57442;</>,<>&#57443;</>,
  <>&#57444;</>,<>&#57445;</>,<>&#57446;</>,<>&#57447;</>,<>&#57448;</>,<>&#57449;</>,
  <>&#57450;</>,<>&#57451;</>,<>&#57452;</>,<>&#57453;</>,<>&#57454;</>,<>&#57455;</>,
  <>&#57456;</>,<>&#57457;</>,<>&#57458;</>,<>&#57459;</>,<>&#57460;</>,<>&#57461;</>,
  <>&#57462;</>,<>&#57463;</>,<>&#57464;</>,<>&#57465;</>,<>&#57466;</>,<>&#57467;</>,
  <>&#57468;</>,<>&#57469;</>,<>&#57470;</>,<>&#57471;</>,<>&#57472;</>,<>&#57473;</>,
  <>&#57474;</>,<>&#57475;</>,<>&#57476;</>,<>&#57477;</>,<>&#57478;</>,<>&#57479;</>,
  <>&#57480;</>,<>&#57481;</>,<>&#57482;</>,<>&#57483;</>,<>&#57484;</>,<>&#57485;</>,
  <>&#57486;</>,<>&#57487;</>,<>&#57488;</>,<>&#57489;</>,<>&#57490;</>,<>&#57491;</>,
  <>&#57492;</>,<>&#57493;</>,<>&#57494;</>,<>&#57495;</>,<>&#57496;</>,<>&#57497;</>,
  <>&#57498;</>,<>&#57499;</>,<>&#57500;</>,<>&#57501;</>,<>&#57502;</>,<>&#57503;</>,
  <>&#57504;</>,<>&#57505;</>,<>&#57506;</>,<>&#57507;</>,<>&#57508;</>,<>&#57509;</>,
  <>&#57510;</>,<>&#57511;</>,<>&#57512;</>,<>&#57513;</>,<>&#57514;</>,<>&#57515;</>,
  <>&#57516;</>,<>&#57517;</>,<>&#57518;</>,<>&#57519;</>,<>&#57520;</>,<>&#57521;</>,
  <>&#57522;</>,<>&#57523;</>,<>&#57524;</>,<>&#57525;</>,<>&#57526;</>,<>&#57527;</>,
  <>&#57528;</>,<>&#57529;</>,<>&#57530;</>,<>&#57531;</>,<>&#57532;</>,<>&#57533;</>,
  <>&#57534;</>,<>&#57535;</>,<>&#57536;</>,<>&#57537;</>,<>&#57538;</>,<>&#57539;</>,
  <>&#57540;</>,<>&#57541;</>,<>&#57542;</>,
];
const LoadingBar=({}):ReactElement=>{
  const[i,si]=useState<number>(0);
  useEffect(()=>{
    const x=setInterval(()=>{si(y=>(y+1)%items.length);},25);
    return ()=>clearInterval(x);
  },[]);
  return(<motion.p className="bcircle">{items[i]}</motion.p>);
}
const Tips=({}):ReactElement=>{
  const[shuffledTips]=useState(()=>{const copy=[...tips];shuffle(copy);return copy;}); //shuffle a local copy instead of mutating the shared imported array
  const[i,si]=useState<number>(0);
  useEffect(()=>{
    const x=setInterval(()=>{si(y=>(y+1)%shuffledTips.length);},3000);
    return ()=>clearInterval(x);
  },[]);
  return(<motion.p className="tips">{shuffledTips[i]}</motion.p>);
}
export const Loading=({}):ReactElement=>{
  return(<>
    <motion.div 
      transition={{duration:0}}
      initial={{opacity:0}}
      animate={{opacity:1}}
      exit={{opacity:0}}
      className="LoadingScreen">
        <motion.div className="Logo"></motion.div>
        <motion.p>Starting Beansite 8.1...</motion.p>
        <br/>
        <Tips/>
        <LoadingBar/>
    </motion.div>
  </>);
}